/* global attachEvent */

// *******************************************************************************
// Open Sidebar-nav in mobile
// *******************************************************************************
attachEvent('.sidebar-nav__button', 'click', (ev) => {
  document.body.classList.toggle('is-open-sidebar');
  ev.preventDefault();
});
